import CompletedOffers from './CompletedOffers';
export default CompletedOffers;
